//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required as validateRequired } from 'vuelidate/lib/validators'

import formValidation from '~/mixins/formValidation'

export default {
  mixins: [formValidation],
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    noGroupOptions: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'select',
    },
    only: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      listeners: {
        change: (event) => this.onInput(event.target.value),
        blur: (event) => this.onInvalid(),
      },
      options: {},
      allowedValues: [],
    }
  },

  async fetch() {
    // fetch countries
    await this.$store.dispatch('locale/fetchWorldCountries')

    // set select options
    if (this.only && this.only.length > 0) {
      const worldCountries = this.$store.getters['locale/getWorldCountries']
      this.options = worldCountries.filter((country) =>
        this.only.includes(country.isoAlpha3)
      )
      this.allowedValues = this.only
    } else if (this.noGroupOptions) {
      const { data, countryCodes } =
        this.$store.getters['locale/getCountriesSelectOptions']
      const countriesOrdened = Object.values(data)
        .flat()
        .sort((a, b) => a.countryName.localeCompare(b.countryName))
      this.options = countriesOrdened
      this.allowedValues = countryCodes
    } else {
      const { data, countryCodes } =
        this.$store.getters['locale/getCountriesSelectOptions']
      this.options = data
      this.allowedValues = countryCodes
    }
  },

  computed: {
    hasAllowedValue() {
      return this.allowedValues.includes(this.value)
    },

    onlyOptions() {
      const options = this.options
      if (this.only && options.length > 0) {
        return options.sort((a, b) =>
          a.countryName > b.countryName
            ? 1
            : b.countryName > a.countryName
            ? -1
            : 0
        )
      }
      return null
    },
  },

  mounted() {
    this.$emit('invalid', {
      invalid: this.$v.$invalid || !this.hasAllowedValue,
      name: this.name,
    })
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
    onInvalid() {
      // reset error
      this.error = null

      // set error
      if (this.required && (!this.$v.value.required || !this.hasAllowedValue)) {
        this.error = this.$translation('form.required')
      }

      // set invalid
      this.invalid = this.$v.$invalid
      this.$emit('invalid', {
        invalid: this.invalid,
        error: this.error,
        name: this.name,
      })
    },
  },
  validations() {
    return {
      value: {
        required: this.required ? validateRequired : true,
      },
    }
  },
}
